import { adminJson, type ListResponse } from './adminJson';

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

const BASE = '/admin';

function qs(params?: Record<string, string | number | boolean | undefined | null>) {
  if (!params) return '';
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue;
    p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}

/** Call an existing Laravel admin route and parse JSON. */
export function adminRequest<T>(
  path: string,
  options: {
    method?: HttpMethod;
    body?: Record<string, unknown> | FormData | null;
    query?: Record<string, string | number | boolean | undefined | null>;
  } = {},
): Promise<T> {
  const method = options.method ?? 'GET';
  const isForm = options.body instanceof FormData;
  let body: BodyInit | undefined;
  if (options.body && method !== 'GET') {
    body = isForm ? (options.body as FormData) : JSON.stringify(options.body);
  }
  return adminJson<T>(`${BASE}${path}${qs(options.query)}`, {
    method,
    body,
    headers: isForm ? undefined : body ? { 'Content-Type': 'application/json' } : undefined,
  });
}

export function adminList<T>(
  path: string,
  query?: Record<string, string | number | boolean | undefined | null>,
) {
  return adminRequest<ListResponse<T>>(path, { method: 'GET', query });
}

/** Normalize Laravel success payloads: {success} | {message} | entity */
export function successMessage(payload: unknown, fallback = 'Saved'): string {
  if (payload && typeof payload === 'object') {
    const p = payload as Record<string, unknown>;
    if (typeof p.success === 'string') return p.success;
    if (typeof p.message === 'string') return p.message;
  }
  return fallback;
}
